// Booking link — single source of truth for "Book a consult" CTAs site-wide.
// Base Calendly page (lists all event types). To deep-link a specific event,
// append its slug, e.g. 'https://calendly.com/buildlabconsulting/15min'.
export const BOOKING_URL = 'https://calendly.com/buildlabconsulting';

// Set to false to hide all booking buttons.
export const BOOKING_ENABLED = true;
